import { Box, Card, CardRootProps, Circle, Icon } from "@chakra-ui/react";
import React, { ComponentProps, PropsWithChildren } from "react";
import { FiArrowUpRight } from "react-icons/fi";

import { SmartLink } from "./smart-link";

type WithHref = {
  href: string;
  // any chakra component is fine here.
  // SmartLink isn't a default chakra component and neither are its inner components so we just use box
  linkProps?: ComponentProps<typeof Box>;
};

type WithoutHref = {
  href?: null | undefined;
  // linkProps does nothing without href but it'll require a refactor to get this typed perfectly.
  // This should be 2 components: hovercard with link and hovercard (without link)
  // but we're going to deal with splitting these components out
  // in a separate PR because it's not worth the effort right now
  linkProps?: ComponentProps<typeof Box>;
};

type BaseProps = PropsWithChildren<{
  cardRootStyles?: CardRootProps;
  showHoverIcon?: boolean;
  disabled?: boolean;
}>;

type HoverCardWithLinkProps = BaseProps & (WithHref | WithoutHref);

export const HoverCardWithLink: React.FC<HoverCardWithLinkProps> = (props) => {
  const {
    children,
    cardRootStyles,
    showHoverIcon = true,
    disabled = false,
  } = props;

  const card = (
    <Card.Root
      borderRadius="3xl"
      overflow="hidden"
      position="relative"
      className="group"
      _hover={{ transform: "scale(0.985)", transition: "transform 0.3s" }}
      pointerEvents={disabled ? "none" : "auto"}
      {...cardRootStyles}
    >
      {/* Hover icon in top-right (only for external links) */}
      {"href" in props && props.href?.startsWith("http") && showHoverIcon && (
        <Circle
          position="absolute"
          top={4}
          right={4}
          size={6}
          bg="white"
          color="gray.600"
          opacity={0}
          _groupHover={{ opacity: 1 }}
          transition="opacity 0.2s"
          zIndex={2}
        >
          <Icon as={FiArrowUpRight} boxSize={4} />
        </Circle>
      )}
      {children}
    </Card.Root>
  );

  // Wrap with <a> only if href is provided
  if ("href" in props && props.href) {
    const { href, linkProps } = props;
    return (
      <SmartLink href={href} {...linkProps}>
        {card}
      </SmartLink>
    );
  }

  return card;
};
